import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener} from "@angular/core";
import { UserService } from "../services/user.service";
import { Store } from "@ngrx/store";
import { State } from "../../app-store";
import { getCurrentUser, ICurrentUser } from "../../app-store/current-user";
import { ConstantsService } from "../services/constants.service";
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { UtilitiesService } from "../services/utilities.service";
import { DataService } from "../services/dataservice";
import { FeedbackService } from "../services/feedback.service";
import { Subscription, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { envName, isIE, environment, user_impersonationScope } from "../../../environments/environment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  userInitials: string | null;
  @Output() userMenuToggle: EventEmitter<void> = new EventEmitter();
  @Output() mainMenuToggle: EventEmitter<boolean> = new EventEmitter();
  @Input() sendCloseMenu: any;
  
  menuIsOpen = false;
  isSfrsUser = false;
  isAdminUser = false;
  istemp = false;
  currentUser: ICurrentUser;
  loggedIn = false;
  loggedInUserName: string | undefined;
  isIframe = false;
  signInRegistrationInProgress = false;
  signInRegistered = false;

   //private subscription: Subscription;
  private readonly _destroying$ = new Subject<void>();
  private getScreenWidth: number;

   constructor(
    private userService: UserService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService, 
    private utilitiesService: UtilitiesService,
    private dataService: DataService,
    private feedbackService: FeedbackService,
   ) {}

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.checkScreenWidth();
    this.setAdminUserStatus();

      //r we set ?
      this.msalBroadcastService.inProgress$
       .pipe(
          filter(
            (status: InteractionStatus) => status === InteractionStatus.None
          ),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          console.log("env: ", envName);
          this.checkAndSetIntAccount();
          this.checkoutAccount();
          this.saveUserInStoreByToken();
      });

      //success event
      this.msalBroadcastService.msalSubject$
      .pipe(
          filter(
            (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
          ),
          takeUntil(this._destroying$)
        )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        this.saveUserInStoreByToken();
      });
   }

  setAdminUserStatus() {
    this.dataService.isCurrentUserAdminUser.subscribe(
      (status) => {
        console.log("SFRS admin User Status via data service", status);
        this.isAdminUser = status;
      }
    );
  }

  checkScreenWidth() {
    this.getScreenWidth = window.innerWidth;
    if (this.getScreenWidth < 1200) {
      this.menuIsOpen = false;
      this.mainMenuToggle.emit(this.menuIsOpen);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkScreenWidth();
  }

  userMenuClicked() {
    this.userMenuToggle.emit();
  }

  toggleMenuClicked() {
    this.menuIsOpen = this.sendCloseMenu;
    this.menuIsOpen = !this.menuIsOpen;
    this.mainMenuToggle.emit(this.menuIsOpen);
  }

  login() {
     const loginRequest = {
      scopes: environment.apiConfig.consentScopes,
      extraScopesToConsent: [ user_impersonationScope ]
    };
    if (isIE) {
      this.authService.loginRedirect(loginRequest);
    } else {
      this.authService.loginPopup(loginRequest);
    }
  }

  checkoutAccount() {
    //console.log("checkout Acc");
    const user = this.userService.getCurrentUser();
    if(user){
      this.loggedIn = !!user;
      this.userInitials = this.userService.getUserInitials();
      this.initialiseDataServiceFromStore();
    }
    else{
      console.log("No current user - checkout acc");
    }
  }

  checkAndSetIntAccount() {
    //console.log("checkAndSetIntAct");
    let activeAccount = this.authService.instance.getActiveAccount();
    if(activeAccount){
      this.userService.account = activeAccount;
    }
  }

  initialiseDataServiceFromStore() {
    if(this.utilitiesService.isCurrentUserAdmin()){
      this.dataService.setCurrentUserAsAdminUser(true);
    }
    else{
       this.dataService.setCurrentUserAsAdminUser(false);
    }
  }

  saveUserInStoreByToken(){
    //console.log("saveUserInStoreByToken");
    var activeAccount = this.authService.instance.getActiveAccount();

    if(activeAccount){
      this.loggedInUserName = activeAccount!.name;
      
      //check user is active
      this.userService.getActiveUserByEmailId(activeAccount!.username).subscribe(
      response => {
          if (response) {
            //must be an admin
            this.userService.checkIfLoggedInUserAdminByEmailId(activeAccount!.username).subscribe(
              response => {

                if (!response) {
                  this.feedbackService.error(
                    "You are not authorised to use the application."
                  );

                  setTimeout(() => {
                    this.authService.logout();
                    localStorage.clear();
                  }, 3000);
                }
                else {
                  this.utilitiesService.saveUserInStore(activeAccount!.username);
                }
              },
              (error) => {
                console.log("hc - error was encountered -> " + error);
              });
        }
        else {
          console.log("hc - No active user by email");
          this.feedbackService.error("There was a problem with auth - no active user");
        }
      },
      (error) => {
        console.log("hc - An error was encountered -> " + error);
        this.feedbackService.error("There was a problem with auth");
      });
    }
    else {
      console.log("hc - No active account");
    }
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.authService.logout();
    localStorage.clear();
  }
}
